import React from 'react';
import { AUTH_SOURCE_TYPE_SPID } from '@client/redux/constants';

import Icon from '@client/components/Icon';
import { getCurrentUrl } from '@client/util/uri';
import { TGeneralConfig } from '@vNext/models/PublicationConfig/GeneralConfig';

const currentUrl = getCurrentUrl(window.location);

export const generalConfig: TGeneralConfig = {
    name: CONFIG.myPage.publication,
    header: {
        logos: [
            {
                link: CONFIG.myPage.frontPageUri,
                image: <Icon name="logos/schibsted" />,
            },
        ],
        availableRedirectUrls: [
            'https://schibsted.no',
        ],
    },
    initializationConfig: {
        redirectUri: currentUrl,
        allowedAuthSources: [AUTH_SOURCE_TYPE_SPID],
    },
    privacyPolicyUrl: 'https://schibsted.com/schibsteds-personvern-og-cookieerklaering/',
};
